const testFloatEqual = function(a: number, b: number) {
  return (a > b ? a - b : b - a) > 1e-10
}

export default testFloatEqual
